"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessJSONModel = void 0;
const AutoSequenceJSONModel_1 = require("src/hello_assets/src/components/model/common/AutoSequenceJSONModel");
const PeriodDaysJSONModel_1 = require("src/hello_assets/src/components/model/common/periodDays/PeriodDaysJSONModel");
const StickinessChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessChartSettingsJSONModel");
const lodash_1 = __importDefault(require("lodash"));
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const RetentionTabsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionTabsJSONModel");
class StickinessJSONModel {
    constructor(serializedState) {
        this.sequenceJSONModel = new AutoSequenceJSONModel_1.AutoSequenceJSONModel();
        this.periodDaysJSONModel = new PeriodDaysJSONModel_1.PeriodDaysJSONModel();
        this.lineTypeJSONModel = new LineTypeJSONModel_1.LineTypeJSONModel();
        this.chartSettingsJSONModel = new StickinessChartSettingsJSONModel_1.StickinessChartSettingsJSONModel();
        this.tabsJSONModel = new RetentionTabsJSONModel_1.RetentionTabsJSONModel();
        this.reset = () => {
            this.sequenceJSONModel.reset();
            this.periodDaysJSONModel.reset();
            this.lineTypeJSONModel.reset();
            this.chartSettingsJSONModel.reset();
            this.tabsJSONModel.reset();
        };
        this.overwriteFromSerializedStateString = (serializedState) => {
            let parsed = undefined;
            try {
                if (lodash_1.default.isString(serializedState)) {
                    parsed = JSON.parse(serializedState);
                }
            }
            catch (e) {
            }
            return this.overwriteFromSerializedState(parsed);
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.sequenceJSONModel.overwriteFromSerializedState(serializedState.sequence);
                this.periodDaysJSONModel.overwriteFromSerializedState(serializedState.period);
                this.lineTypeJSONModel.overwriteFromSerializedState(serializedState.lineType);
                this.chartSettingsJSONModel.overwriteFromSerializedState(serializedState.chart);
                this.tabsJSONModel.overwriteFromSerializedState(serializedState.tabs);
            }
        };
        this.serialize = () => {
            return {
                sequence: this.sequenceJSONModel.serialize(),
                period: this.periodDaysJSONModel.serialize(),
                lineType: this.lineTypeJSONModel.serialize(),
                chart: this.chartSettingsJSONModel.serialize(),
                tabs: this.tabsJSONModel.serialize(),
            };
        };
        this.getSequenceJSONModel = () => this.sequenceJSONModel;
        this.getPeriodDaysJSONModel = () => this.periodDaysJSONModel;
        this.getLineTypeJSONModel = () => this.lineTypeJSONModel;
        this.getChartSettingsJSONModel = () => this.chartSettingsJSONModel;
        this.getTabsJSONModel = () => this.tabsJSONModel;
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.StickinessJSONModel = StickinessJSONModel;
////////////////////////////////////////////////
// ...
////////////////////////////////////////////////
StickinessJSONModel.getDefaultModel = () => {
    return new StickinessJSONModel().serialize();
};
////////////////////////////////////////////////
// URL state validator
////////////////////////////////////////////////
StickinessJSONModel.isModelEmpty = (serializedState) => {
    var _a, _b;
    const jsonModel = new StickinessJSONModel(serializedState);
    const tabsJSONModel = jsonModel.getTabsJSONModel();
    const activeTabUniqueId = tabsJSONModel.getActiveUniqueId();
    const numberOfCohortVariants = (_a = tabsJSONModel.getCohortJSONModel(activeTabUniqueId)) === null || _a === void 0 ? void 0 : _a.getNumberOfQueryEventVariants();
    const numberOfReturnVariants = (_b = tabsJSONModel.getReturnJSONModel(activeTabUniqueId)) === null || _b === void 0 ? void 0 : _b.getNumberOfQueryEventVariants();
    return (numberOfCohortVariants || 0) === 0 || (numberOfReturnVariants || 0) === 0;
};
StickinessJSONModel.makeModelStateClean = (serializedState) => {
    var _a, _b;
    const jsonModel = new StickinessJSONModel(serializedState);
    const tabsJSONModel = jsonModel.getTabsJSONModel();
    const activeTabUniqueId = tabsJSONModel.getActiveUniqueId();
    (_a = tabsJSONModel.getCohortJSONModel(activeTabUniqueId)) === null || _a === void 0 ? void 0 : _a.removeNotFilledQueryEventVariants();
    (_b = tabsJSONModel.getReturnJSONModel(activeTabUniqueId)) === null || _b === void 0 ? void 0 : _b.removeNotFilledQueryEventVariants();
    return jsonModel.serialize();
};
